// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import _ from 'lodash';
import OlSourceVector from 'ol/source/vector';
import OlFeature from 'ol/feature';
import OlLayerVector from 'ol/layer/vector';
import OlStyleStyle from 'ol/style/style';
import OlStyleIcon from 'ol/style/icon';
import OlFormatWKT from 'ol/format/wkt';
import { selectComment, getComments } from './../../../../actions/comments';
import { getSelectInteractionManager } from './../../../../utilities/selectInteractionManager';
import { getDrawInteractionManager } from './../../../../utilities/drawInteractionManager';
import CommentsIcon from './../../../../icons/Comment.svg';
import CommentSelectedIcon from './../../../../icons/Comment_selected.svg';
import { finishDrawingCommentGeometry } from './../../../../actions/comments';
import { setSelectedTabNameAction } from './../../../../actions/modules';

const COMMENTS_LAYER_NAME = 'Comments';

export class Commentslayer extends React.Component {
    commentSource = null;
    displayedFeatures = [];

    constructor(props) {
        super(props);
        this.commentSource = new OlSourceVector();
        const commentLayer = new OlLayerVector({
            source: this.commentSource,
            zIndex: 1000003,
            showInLegend: true,
            visible: true,
            name: COMMENTS_LAYER_NAME,
            style: new OlStyleStyle({
                image: new OlStyleIcon({
                    src: CommentsIcon
                })
            })
        });
        props.olMap.addLayer(commentLayer);
        this.addCommentSelectFeatureInteraction();
    }

    addCommentSelectFeatureInteraction() {
        const selectConfig = {
            style: new OlStyleStyle({
                image: new OlStyleIcon({
                    src: CommentSelectedIcon
                })
            }),
            idColumnName: 'id',
            layerName: COMMENTS_LAYER_NAME,
            onFeatureSelect: this.onCommentFeatureSelect.bind(this),
        };
        getSelectInteractionManager('map').addSelectConfig(selectConfig);
    }

    onCommentFeatureSelect(id) {
        const { selectComment, comments } = this.props;
        selectComment(comments.find(comment => comment.id === id));
    }

    selectCommentFeature() {
        const { selectedComment, setSelectedTabName } = this.props;
        if (selectedComment) {
            setSelectedTabName('comments')
            const selectedFeature = this.displayedFeatures.find(feature => {
                return feature.get('id') === selectedComment.id;
            });
            getSelectInteractionManager('map').selectFeature(COMMENTS_LAYER_NAME, selectedFeature);
        } else {
            getSelectInteractionManager('map').selectFeature(COMMENTS_LAYER_NAME, null);
        }
    }

    updateCommentFeatures() {
        const { comments } = this.props;
        this.displayedFeatures = [];
        this.commentSource.clear();
        if (!comments) return;

        this.displayedFeatures = comments
            .filter(comment => comment.geomWkt)
            .map(comment => {
                const format = new OlFormatWKT();
                const feature = format.readFeature(comment.geomWkt);
                feature.set('id', comment.id);
                feature.set('layerName', COMMENTS_LAYER_NAME);
                this.commentSource.addFeature(feature);
                return feature;
            });
    }

    startDrawingComment() {
        const { olMap, drawingComment, finishDrawingCommentGeometry } = this.props;
        if (!drawingComment) return;

        getDrawInteractionManager('map').startDrawing(olMap, 'Point', null, (geom) => { 
            let selectedFeature = this.displayedFeatures.find(feature => {
                return feature.get('id') === drawingComment.id;
            });  
            if (!selectedFeature) {
                this.commentSource.clear();
                selectedFeature = new OlFeature();
                selectedFeature.set('layerName', COMMENTS_LAYER_NAME);
                this.commentSource.addFeature(selectedFeature);
            }   
            selectedFeature.setGeometry(geom);
            this.commentSource.refresh();

            getSelectInteractionManager('map').selectFeature(COMMENTS_LAYER_NAME, selectedFeature);

            const format = new OlFormatWKT();
            const geomWkt = format.writeGeometry(geom);                        
            drawingComment.geomWkt = geomWkt;
            finishDrawingCommentGeometry();                                     
        });
    }

    finishDrawingComment(removeFeature) {
        const { olMap } = this.props;
        getDrawInteractionManager('map').finishDrawing(olMap, true);
    }

    componentDidMount() {
        const { axiosInstance, getComments } = this.props;
        getComments(axiosInstance);
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.comments, this.props.comments)) {
            this.updateCommentFeatures();
            this.selectCommentFeature();
        }
        else if (!_.isEqual(prevProps.selectedComment, this.props.selectedComment)) {
            this.selectCommentFeature();
        }
        if (prevProps.drawingComment === this.props.drawingComment) return;
        if (this.props.drawingComment === 'finished') {
            this.finishDrawingComment(false);
        } else if (this.props.drawingComment === 'canceled') {
            this.updateCommentFeatures();
            this.selectCommentFeature();
            this.finishDrawingComment(true);
        } else if (this.props.drawingComment) {
            this.startDrawingComment();
        }
    }

    render() {
        return (null);
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    drawingComment: state.comments.get('drawingComment'),
    selectedComment: state.comments.get('selectedComment'),
    comments: state.comments.get('comments'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    selectComment,
    getComments,
    finishDrawingCommentGeometry,
    setSelectedTabName: setSelectedTabNameAction
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Commentslayer)


// WEBPACK FOOTER //
// ./src/containers/content/map/comments/CommentsLayer.jsx